import Brands from "../components/LandingPage/Brands";
import FeatureCard from "../components/LandingPage/FeatureCard";
import Testimonials from "../components/LandingPage/Testimonials";
import EnterpriseBanner from "../components/Priser/EnterpriseBanner";
import FaqSection from "../components/Priser/FaqSection";
import FeatureTable from "../components/Priser/FeatureTable";
import HeroSection from "../components/Priser/HeroSection";
import PrisModeller from "../components/Priser/PrisModeller";
import PublicLayout from "../layout/PublicLayout";

export default function Priser() {
  return (
    <PublicLayout>
      <HeroSection />
      <PrisModeller />
      <EnterpriseBanner />
      <FeatureTable />
      <FeatureCard />
      <FaqSection />
      <Testimonials />
      <Brands />
    </PublicLayout>
  );
}
